storefrontApp.controller("customerShowcaseQuickViewController", [
    "$q",
    "$scope",
    "$window",
    "customerReviewService",
    "elasticService",
    "loaderService",
    "modalService",
    "urlService",
    function (
        $q,
        $scope,
        $window,
        customerReviewService,
        elasticService,
        loaderService,
        modalService,
        urlService
    ) {
        //#region Fields
        $scope.customerShowcaseQuickView = {
            currentReview: null,
            elasticProductInfo: null,
            individualRatingCountArray: [],
            searchCriteria: {
                categoryIds: null,
                pageNumber: 1,
                pageSize: 4,
                productDefinitions: null,
                productId: null,
                ratings: null,
                searchPhrase: null,
                sort: null,
                vendors: null,
                years: null,
            },
            searchResults: [],
            totalCount: 0,
            totalPages: 0,
            totalIndividualRatingCount: 0,
        };
        //#endregion

        //#region Events
        $scope.$on(
            "InitializeCustomerShowcaseQuickView",
            function (_event, productId) {
                $scope.customerShowcaseQuickView.searchCriteria.productId =
                    productId;
                initializeCustomerShowcaseQuickView();
            }
        );
        //#endregion

        //#region Customer Showcase Quick View
        $scope.closeCustomerShowcaseQuickView = function () {
            modalService.close("customerShowcaseQuickViewModal");
            resetCustomerShowcaseQuickView();
        };

        $scope.getProgressStyle = function (individualCount) {
            if (individualCount > 0) {
                var colorPercentage =
                    (individualCount /
                        $scope.customerShowcaseQuickView
                            .totalIndividualRatingCount) *
                    100;
                return (
                    "linear-gradient(to right, #EB5102 " +
                    colorPercentage +
                    "%, white " +
                    colorPercentage +
                    "%)"
                );
            } else return null;
        };

        $scope.nextPageReviews = function () {
            $scope.customerShowcaseQuickView.searchCriteria.pageNumber++;
            searchCustomerShowcaseReviews();
        };

        $scope.previousPageReviews = function () {
            $scope.customerShowcaseQuickView.searchCriteria.pageNumber--;
            searchCustomerShowcaseReviews();
        };

        $scope.redirectToUrl = function (url) {
            $window.open(url, "_blank");
        };

        //#region Private Functions
        function initializeCustomerShowcaseQuickView() {
            loaderService.show();
            $q.all([
                customerReviewService.searchCustomerShowcaseReviews(
                    $scope.customerShowcaseQuickView.searchCriteria
                ),
                elasticService.getElasticData(
                    elasticService.buildProductInfoRequest(
                        $scope.customerShowcaseQuickView.searchCriteria.productId
                            .split("_var_")[0]
                            .toLowerCase()
                    )
                ),
                customerReviewService.getCustomerShowcaseIndividualRatingCount(
                    $scope.customerShowcaseQuickView.searchCriteria.productId
                ),
            ]).then(function (responses) {
                loaderService.hide();

                //Search results
                $scope.customerShowcaseQuickView.searchResults = _.get(
                    responses,
                    ["0", "data", "results"]
                );
                $scope.customerShowcaseQuickView.totalCount = _.get(responses, [
                    "0",
                    "data",
                    "totalCount",
                ]);
                $scope.customerShowcaseQuickView.currentReview =
                    $scope.customerShowcaseQuickView.searchResults[0];
                $scope.customerShowcaseQuickView.totalPages =
                    $scope.customerShowcaseQuickView.totalCount /
                    $scope.customerShowcaseQuickView.searchCriteria.pageSize;

                _.forEach(
                    $scope.customerShowcaseQuickView.searchResults,
                    function (item) {
                        item.customPropProductImageUrl = urlService.getImageUrl(
                            {
                                catalogId: item.vendorName,
                                definitionName: item.productDefinition,
                                size: "medium",
                                sku: item.productId,
                            }
                        );
                        item.customPropProductUrl = urlService.getProductUrl({
                            catalogId: item.vendorName,
                            definitionName: item.productDefinition,
                            name: item.title,
                            sku: item.productId,
                        });
                    }
                );

                //Elastic product info
                $scope.customerShowcaseQuickView.elasticProductInfo = _.get(
                    responses,
                    ["1", "data", "hits", "hits", "0", "_source"]
                );
                _.forEach(
                    $scope.customerShowcaseQuickView.searchResults,
                    function (item) {
                        item.customPropBrandUrl = urlService.getBrandUrl({
                            catalogId: item.vendorName,
                            productDefinition: item.productDefinition,
                            productType: $scope.customerShowcaseQuickView.elasticProductInfo == null || $scope.customerShowcaseQuickView.elasticProductInfo.productType == null ? "Digital" : $scope.customerShowcaseQuickView.elasticProductInfo.productType,
                        });
                    }
                );

                //Individual rating count
                $scope.customerShowcaseQuickView.individualRatingCountArray =
                    _.get(responses, ["2", "data"], "").split(",");
                $scope.customerShowcaseQuickView.individualRatingCountArray =
                    _.map(
                        $scope.customerShowcaseQuickView
                            .individualRatingCountArray,
                        function (item) {
                            return parseInt(item);
                        }
                    );
                $scope.customerShowcaseQuickView.totalIndividualRatingCount =
                    _.reduce(
                        $scope.customerShowcaseQuickView
                            .individualRatingCountArray,
                        function (memo, num) {
                            return memo + num;
                        },
                        0
                    );

                modalService.open("customerShowcaseQuickViewModal");
            });
        }

        function resetCustomerShowcaseQuickView() {
            $scope.customerShowcaseQuickView = {
                currentReview: null,
                elasticProductInfo: null,
                individualRatingCountArray: [],
                searchCriteria: {
                    categoryIds: null,
                    pageNumber: 1,
                    pageSize: 4,
                    productDefinitions: null,
                    productId: null,
                    ratings: null,
                    searchPhrase: null,
                    sort: null,
                    vendors: null,
                    years: null,
                },
                searchResults: [],
                totalCount: 0,
                totalPages: 0,
                totalIndividualRatingCount: 0,
            };
        }

        function searchCustomerShowcaseReviews() {
            loaderService.show();
            customerReviewService
                .searchCustomerShowcaseReviews(
                    $scope.customerShowcaseQuickView.searchCriteria
                )
                .then(function (response) {
                    loaderService.hide();

                    //Search Results
                    $scope.customerShowcaseQuickView.searchResults = _.get(
                        response,
                        ["data", "results"]
                    );
                    $scope.customerShowcaseQuickView.totalCount = _.get(
                        response,
                        ["data", "totalCount"]
                    );
                    $scope.customerShowcaseQuickView.currentReview =
                        $scope.customerShowcaseQuickView.searchResults[0];
                    $scope.customerShowcaseQuickView.totalPages =
                        $scope.customerShowcaseQuickView.totalCount /
                        $scope.customerShowcaseQuickView.searchCriteria
                            .pageSize;
                    _.forEach(
                        $scope.customerShowcaseQuickView.searchResults,
                        function (item) {
                            item.customPropBrandUrl = urlService.getBrandUrl({
                                catalogId: item.vendorName,
                                productDefinition: item.productDefinition,
                                productType:
                                    $scope.customerShowcaseQuickView
                                        .elasticProductInfo.productType,
                            });
                            item.customPropProductImageUrl =
                                urlService.getImageUrl({
                                    catalogId: item.vendorName,
                                    definitionName: item.productDefinition,
                                    size: "medium",
                                    sku: item.productId,
                                });
                            item.customPropProductUrl =
                                urlService.getProductUrl({
                                    catalogId: item.vendorName,
                                    definitionName: item.productDefinition,
                                    name: item.title,
                                    sku: item.productId,
                                });
                        }
                    );

                    modalService.open("customerShowcaseQuickViewModal");
                });
        }
        //#endregion

        //#endregion
    },
]);
